import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useT } from "../i18n";

export const inputCls = "w-full min-h-[48px] rounded-xl border border-[#0D4045]/15 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#0D4045]/30";

export default function PasswordInput({ value, onChange, testid, toggleTestid, minLength }) {
  const { t } = useT();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input data-testid={testid} type={show ? "text" : "password"} required minLength={minLength}
        placeholder={t("login.password")} value={value} onChange={onChange} className={inputCls + " pr-12"} />
      <button type="button" data-testid={toggleTestid} onClick={() => setShow(!show)}
        aria-label={t("login.show_password")}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-[#6B7280] hover:text-[#0D4045] transition-colors duration-200">
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
